import { render, staticRenderFns } from "./product_group.vue?vue&type=template&id=0df1853c&scoped=true"
import script from "./product_group.vue?vue&type=script&lang=js"
export * from "./product_group.vue?vue&type=script&lang=js"
import style0 from "./product_group.vue?vue&type=style&index=0&id=0df1853c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df1853c",
  null
  
)

export default component.exports